import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TrapFocusDirective } from './trap-focus.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [TrapFocusDirective],
  exports: [TrapFocusDirective],
})
export class TrapFocusModule {}
